import React from "react";
import Gallery from "react-photo-gallery";

class MultiSelectedImageCaptcha extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedArr:[],
      photos:[]    
    };
  }
 

  imageRenderer = ({ index, left, top, key, photo }) => {
  	return (
		<>
		<SelectedImage
        key={key}
        margin={"2px"}
        index={index}
        photo={photo}
        left={left}
        top={top}  
        onClickImage={this.handleImageClick}
        isSelected={photo.isSelected}
        images={this.props.image}
			maxSelections = { this.props.maxSelections }
      />
    </>
    )
   };

  handleImageClick = async( event, { photo , index, } ) =>{     
      var images = this.props.image;
   
      var img = images[index];
      if (img !== undefined) {
        if (img.hasOwnProperty("isSelected")) {
          img.isSelected = !img.isSelected;

        } else {
          img.isSelected = true;
        }
        this.setState({photos: images});
        
        this.props.handleChange(null, img, this.props.rateeKey, index, "type");
      } else {
        console.log("error")
      }
  }

  render() {
    const {image} = this.props;
    return (
	<div>
		<Gallery 
			photos={image} 
			renderImage={this.imageRenderer}
		/>
	</div> 
    );
  }
}

class SelectedImage extends React.Component {
  constructor(props) {
		super(props);
		this.state = {
			isChecked:false
		};
	}

	componentDidMount() {
        
    setTimeout(() => {
      this.setState({isChecked: this.props.images[this.props.index].isSelected})	
    }, 300);
}


	handleOnClick = 
	async(event, photo, index) => {
		var selectedImages = document.getElementsByClassName(`selected`);
		if((selectedImages.length) >= this.props.maxSelections){
			this.setState({isChecked: false});
		} else {
      this.setState({isChecked: !this.state.isChecked});
		}
		this.props.onClickImage(event,{photo,index})
	};

	render() {
		const { index, photo, margin, direction} = this.props;

		const cont = {
		backgroundColor: "#eee",
		cursor: "pointer",
		overflow: "hidden",
		position: "relative",
		width:"",
		height:"",
		display:"flex",
		justifyContent:"space-around"
		};

		if (direction === "column") {
			cont.position = "absolute";
			cont.width="200px"
		}  
    
    return (
      <div
        style={{ margin, ...cont }}
        className={!this.state.isChecked ? "not-selected" : "selected"}
       >
        <CheckMark selected={this.state.isChecked ? true : false} />
        <img
          alt={photo.src}
          style={ { ...imgStyle } }
          {...photo}
          onClick={(event)=>this.handleOnClick(event, photo, index)}
        />
        <style>{`.not-selected:hover{outline:2px solid #06befa},.selected:{}`}</style>
      </div>
    );
  }
}

const CheckMark = ({ selected }) => (
  
    <div
      style={
        selected
          ? { left: "4px", top: "4px", position: "absolute", zIndex: "1" }
          : { display: "none" }
      }
    >
      <svg
        style={{ fill: "white", position: "absolute" }}
        width="24px"
        height="24px"
      >
        <circle cx="12.5" cy="12.2" r="8.292" />
      </svg>
      <svg
        style={{ fill: "#06befa", position: "absolute" }}
        width="24px"
        height="24px"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
      </svg>
    </div>
);

const imgStyle = {
  display:"flex",
  width:"290px",
  height:"200px",
  transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};


export default MultiSelectedImageCaptcha;

